import {
  createUserWithEmailAndPassword,
  reauthenticateWithCredential,
  signInWithEmailAndPassword,
  updatePassword,
  verifyBeforeUpdateEmail,
} from 'firebase/auth';

import { auth, emailAuthCredential } from './firebase';

export const doCreateUserWithEmailAndPassword = async (email, password) => {
  return createUserWithEmailAndPassword(auth, email, password);
};

export const doSignInWithEmailAndPassword = async (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};

export const doSignOut = () => {
  return auth.signOut();
};

export const doPasswordChange = (password) => {
  return updatePassword(auth.currentUser, password);
};

export const doEmailChange = async (email) => {
  return verifyBeforeUpdateEmail(auth.currentUser, email);
};

export const doReauthenticateUser = async (password) => {
  const credential = emailAuthCredential(auth.currentUser, password);
  return reauthenticateWithCredential(auth.currentUser, credential);
};
